interface LogoProps {
    size?: number
}

export function Logo({ size = 32 }: LogoProps) {
    // Size is in Tailwind units (1 = 0.25rem = 4px), so convert to pixels
    const pixelSize = size * 4;

    return (
        <>
            <div
                class="flex-none rounded-2xl shadow-lg"
                style={{
                    width: `${pixelSize}px`,
                    height: `${pixelSize}px`,
                    background: 'linear-gradient(60deg, #f79533, #f37055, #ef4e7b, #a166ab, #5073b8, #1098ad, #07b39b, #6fba82)',
                    backgroundSize: '400% 400%',
                    animation: 'gradient 10s ease infinite',
                }}
            />
            <style>{`
          @keyframes gradient {
            0% {
              border-radius: 35%;
              transform: rotate(0deg) scale(1);
              background-position: 0% 50%;
            }
            40% {
              border-radius: 45%;
              transform: rotate(270deg) scale(1.1);    
              background-position: 100% 25%;
            }
            100% {
              border-radius: 35%;
              transform: rotate(360deg) scale(1);
              background-position: 0% 50%;
            }
          }
        `}</style>
        </>
    );
}